import { render, staticRenderFns } from "./buildnew.vue?vue&type=template&id=028164d8&scoped=true"
import script from "./buildnew.vue?vue&type=script&lang=js"
export * from "./buildnew.vue?vue&type=script&lang=js"
import style0 from "./buildnew.vue?vue&type=style&index=0&id=028164d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028164d8",
  null
  
)

export default component.exports